import { ThemeName } from '@im/im-theme';
import { createContext } from 'react';

export type StorefrontInfo = {
  colorScheme: ThemeName | null;
  createdDate: string | null;
  deploymentStatus: string | null;
  displayName: string | null;
  domainInfo: {
    domainName: string | null;
    domainType: string | null;
    sslCertificate: string | null;
  } | null;
  favicon: string | null;
  firstName: string | null;
  lastName: string | null;
  linkLabel: string | null;
  logo: string | null;
  marketplaceId: string | null;
  marketplaceStatus: string | null;
  modifiedDate: string | null;
  socialMediaInfo: Array<{
    link: string | null;
    platform: string | null;
  }>;
  supportEmail: string | null;
  supportLink: string | null;
  supportPhoneNumber: string | null;
  termsAndConditions: string | null;
};

export const storefrontInfoContext = createContext<StorefrontInfo | undefined>(
  undefined
);
